import React, { useEffect, useRef } from 'react';
import './App.css';
import logo from './bglogo.png';

const games = [
  { icon: '🏏', name: 'Cricket' },
  { icon: '⚽', name: 'Football' },
  { icon: '🎾', name: 'Tennis' },
  { icon: '🎰', name: 'Casino' },
  { icon: '🃏', name: 'Live Poker' },
];

const features = [
  '⚡ Instant ID Activation',
  '⚡ 24/7 Deposit & Withdrawal',
  '⚡ Fastest Payments Guaranteed',
];

export default function App() {
  const particlesRef = useRef(null);

  useEffect(() => {
    const canvas = particlesRef.current;
    const ctx = canvas.getContext('2d');

    const resize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };
    resize();

    const particles = Array.from({ length: 55 }, () => ({
      x: Math.random() * canvas.width,
      y: Math.random() * canvas.height,
      r: Math.random() * 2 + 0.4,
      dx: (Math.random() - 0.5) * 0.35,
      dy: (Math.random() - 0.5) * 0.35,
      alpha: Math.random() * 0.55 + 0.15,
    }));

    let raf;
    const draw = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      particles.forEach(p => {
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(255,196,0,${p.alpha})`;
        ctx.fill();
        p.x += p.dx;
        p.y += p.dy;
        if (p.x < 0 || p.x > canvas.width)  p.dx *= -1;
        if (p.y < 0 || p.y > canvas.height) p.dy *= -1;
      });
      raf = requestAnimationFrame(draw);
    };
    draw();

    window.addEventListener('resize', resize);
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener('resize', resize);
    };
  }, []);

  const handleGetId = () => {
    window.open('https://www.kaalbet.info/conect01', '_blank');
  };

  return (
    <div className="app">
      <canvas ref={particlesRef} className="particles" />
      <div className="bg-glow" />

      <div className="container">

        {/* Logo */}
        <div className="logo-wrap">
          <img src={logo} alt="KAALBET Logo" className="logo" />
        </div>

        {/* Title */}
        <div className="title-block">
          <p className="tagline">King of Online Gaming</p>
          <div className="badge">🏆 ASIA'S FASTEST GROWING PLATFORM</div>
        </div>

        {/* Trust */}
        <div className="trust-row">
          <span className="trust-badge">✅ TRUSTED &amp; VERIFIED PLATFORM</span>
        </div>

        {/* CTA */}
        <div className="cta-section">
          <button className="cta-btn" onClick={handleGetId}>
            <span className="cta-dot">🟢</span>
            GET YOUR ID NOW
            <span className="cta-arrow">→</span>
          </button>
          <div className="features">
            {features.map((f, i) => (
              <div key={i} className="feature-item">{f}</div>
            ))}
          </div>
        </div>

        {/* Games */}
        <div className="games-section">
          <h2 className="games-title">🎮 AVAILABLE GAMES</h2>
          <div className="games-grid">
            {games.map((g, i) => (
              <div key={i} className="game-card">
                <span className="game-icon">{g.icon}</span>
                <span className="game-name">{g.name}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Footer */}
        <div className="footer">
          <span>© 2025 KAALBET · All Rights Reserved</span>
        </div>

      </div>
    </div>
  );
}
